<div id="app">
  <app-selector (languageChange)="onLanguageChange($event)" [initLanguage]="language"></app-selector>
  <div class="loading" *ngIf="isLoading">
    <img src="assets/images/loading.png" />
  </div>
  <img [src]="image" (load)="onImageLoaded()" />
</div>